function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.35664 3.31667C9.35664 2.20898 10.2656 1.3 11.3733 1.3H30.7233V13.9833C30.7233 15.091 29.8143 16 28.7066 16H28.0233V4H9.35664V3.31667ZM8.05664 4V3.31667C8.05664 1.49101 9.54766 0 11.3733 0H32.0233V13.9833C32.0233 15.809 30.5323 17.3 28.7066 17.3H28.0233V17.9833C28.0233 19.809 26.5323 21.3 24.7066 21.3H24.0233V21.7167C24.0233 23.6757 22.399 25.3 20.44 25.3H0.0566406V11.5833C0.0566406 9.62435 1.68099 8 3.63997 8H4.05664V7.31667C4.05664 5.49101 5.54766 4 7.37331 4H8.05664ZM7.37331 5.3C6.26563 5.3 5.35664 6.20898 5.35664 7.31667V8H24.0233V20H24.7066C25.8143 20 26.7233 19.091 26.7233 17.9833V5.3H7.37331ZM3.63997 9.3C2.39896 9.3 1.35664 10.3423 1.35664 11.5833V24H20.44C21.681 24 22.7233 22.9577 22.7233 21.7167V9.3H3.63997Z",
  fill: "#2F7067"
});

var SvgStacks = function SvgStacks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStacks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stacks.0785baac.svg";
export { ForwardRef as ReactComponent };